






































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { Vat, VatVolumeReference } from '@/api';
import { VatCorrectionService } from '@/services/vat-correction-service';
import Toast from '@/components/display/toast.vue';
import { CustomFormulaResult } from '@/typings/custom-formula-calculator';

@Component({
	components: {},
})
export default class MilkVatReferencesList extends Vue {
	public referenceFields: { key: string; label: string }[] = [];

	@Prop()
	public vat!: Vat;

	@Prop()
	public parameters!: Record<string, string | number>;

	@PropSync('savedReferences')
	public _savedReferences!: VatVolumeReference[];

	@Prop()
	public correction: any | null;

	public deletingReferences: boolean = false;
	public selectedReferences: any[] = [];

	private vatCorrectionService: VatCorrectionService = new VatCorrectionService();
	private toast = new Toast();

	public created() {
		this.onVatChanged()
	}

	@Watch('vat', { immediate: true, deep: true })
	public async onVatChanged() {
		this.referenceFields = [
			{ key: 'sel', label: '' },
			{ key: 'event_timestamp', label: 'Date' },
			{ key: 'volume', label: 'Reference Volume' },
			{ key: 'original_volume', label: 'Levno Volume' },
			{ key: 'new_volume', label: `New Volume` },
			{ key: 'diff', label: 'Difference' },
			{ key: 'notes', label: 'Notes' },
			{ key: 'user_id', label: 'By' },
		];
		await this.loadReferences();
	}

	public async loadReferences(callApi: boolean = true): Promise<void> {
		type VatVolumeReferenceWithNewVolume = VatVolumeReference & {
			new_volume?: number;
		}
		let data: VatVolumeReferenceWithNewVolume[] = this._savedReferences ?? [];
		if (callApi) {
			const referencesResult = await this.vatCorrectionService.getReferences(this.vat.id);
			if (referencesResult?.errorMessage) {
				return;
			}
			data = referencesResult.references ?? [];
		}

		const references = [];
		for (const i in data) {
			const reference = data[i];

			let additionalVatParams: any = {
				emptyDistance: this.vat.emptyDistance,
				volumeCalibration: this.vat.volumeCalibration,
			};
			if (additionalVatParams.emptyDistance == undefined) {
				delete additionalVatParams.emptyDistance;
			}

			const vol: {
				result?: CustomFormulaResult | Error;
				error?: string;
			} = await VatCorrectionService.calculateMilkVatVolume(
				[(reference?.additional_parameters as any).start_distance ?? 9999],
				additionalVatParams,
				this.vat,
				this.parameters,
				this.correction,
			);

			if (vol.error)
				this.toast.makeToast('Error calculating reference', 'Error', 'danger');
			else
				reference.new_volume = ((<CustomFormulaResult>vol.result)?.volume) ?? 0;

			references.push(reference);
		}
		this._savedReferences = references;
	}

	public unit(value?: number) {
		return !value
			? ''
			: this.$options.filters?.numeric(value) + ' L';
	}

	public async deleteReferences(): Promise<void> {
		const promises = [];
		this.deletingReferences = true;
		let errored = false;

		for (const reference of this.selectedReferences) {
			const promise = this.vatCorrectionService
				.deleteReference(this.vat.id, reference.id)
				.then((res) => {
					if (res?.errorMessage) {
						this.toast.makeToast(res.errorMessage, 'Error', 'danger');
						errored = true;
					}
				});
			promises.push(promise);
		}

		await Promise.all(promises);

		this._savedReferences = this._savedReferences.filter(
			reference => this.selectedReferences.map(c => c.id).indexOf(reference.id) === -1,
		);
		this.selectedReferences = [];

		if (!errored)
			this.toast.makeToast('Successfully deleted all selected references', 'Success', 'success');
		this.deletingReferences = false;
	}
}
